import { Action } from '@canvas/model/permissions';

import { policyAction, type PersistentPolicy } from '../../policy-manager-types';

export const canDeleteCommentPolicy: PersistentPolicy = {
  id: 'can-delete-comment',
  type: 'persistent',
  rule: (state) => {
    const canDelete = policyAction(Action['delete/comment']);
    if (state.has(canDelete)) {
      return { can: canDelete };
    }
    return { cannot: canDelete };
  },
};
